export default function ($el) {
  const Tabs = {
    init: function () {
      this.bindUIfunctions();
      this.pageLoadCorrectTab();
    },

    bindUIfunctions: function () {
      $el
        .on('click', '.transformer-tabs li a', function (event) {
          if (($(event.target).attr('href') || '').startsWith('#')) {
            event.preventDefault();
            Tabs.changeTab(this.hash);
          } else {
            Tabs.loadOutboundTab(event);
          }
        })
        .on('click', '.transformer-tabs ul:not(".open")', (event) => {
          Tabs.toggleMobileMenu(event);
        });
    },

    changeTab: function (hash) {
      const anchor = $(`[href='${hash}']`);
      const div = $(`#${$.escapeSelector(hash.substring(1))}`);

      // activate correct anchor (visually)
      anchor.parent().addClass('active').siblings().removeClass('active');

      // activate correct div (visually)
      div.addClass('active').siblings().removeClass('active');

      // update URL, no history addition
      window.history.replaceState('', '', hash);

      // Close menu, in case mobile
      anchor.closest('ul').removeClass('open');
    },

    loadOutboundTab: function (event) {
      if ($(event.target).closest('li').hasClass('active')) {
        event.preventDefault();
      } else {
        $(event.target)
          .parent()
          .addClass('loading')
          .siblings()
          .removeClass('active');
      }
      $(event.target).closest('ul').removeClass('open');
    },

    // If the page has a hash on load, go to that tab
    pageLoadCorrectTab: function () {
      if (document.location.hash) {
        this.changeTab(document.location.hash);
      }
    },

    toggleMobileMenu: function (event) {
      $(event.target).closest('ul').toggleClass('open');
    },
  };

  Tabs.init();
}
